import { render, staticRenderFns } from "./SocialSeriesCustomFields.vue?vue&type=template&id=b4ffe21e&scoped=true&"
import script from "./SocialSeriesCustomFields.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SocialSeriesCustomFields.vue?vue&type=style&index=0&id=b4ffe21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ffe21e",
  null
  
)

export default component.exports